export default [
  {
    path: 'consultas/instalacoes',
    name: 'instalacoes',
    component: () => import('./index'),
    children: [],
    meta: {
      visible: true,
      title: 'Instalações',
      breadcrumb: [
        { name: 'Home', link: 'home' },
        { name: 'Consultas', link: 'consultas' },
        { name: 'Instalações', },
      ]
    }
  },
]